import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { compose } from 'recompose';
import { routes } from '../../../constants';
import { Icon } from '../../components';

const Completed = ({ lastSavedContentType }) => (
  <div id='section--add-content-questions'>
    <Grid>
      <h1 className='text-center'>&nbsp;</h1>
      <Row className='md-gutter'>
        <Col xs={12} md={6} mdOffset={3} className='boxed'>
          <div className='complete'>
            <Icon icon='caddie-the-dog' />
            <div className='h1'>Complete</div>
            <p>Your {fp.lowerCase(lastSavedContentType)} has been Caddiefied! Advisers can now earn CPD for your {fp.lowerCase(lastSavedContentType)}.</p>
            <p>
              <LinkContainer exact className='large full' to={routes.publisherPortal.dashboard}>
                <Button>I'm done</Button>
              </LinkContainer>
            </p>
          </div>
        </Col>
      </Row>
    </Grid>
  </div>
);

export default compose(
  connect((state) => ({
    lastSavedContentType: state.publisherPortal.content.lastSavedContentType
  })),
)(Completed);



// WEBPACK FOOTER //
// ./src/containers/pages/publisher-portal/completed.js